import type { RoleInUseDialogProps } from "./types-role-in-use-dialog";
import { useRoleInUseDialog } from "./use-role-in-use-dialog";
import { RoleInUseDialogView } from "./view-role-in-use-dialog";

/** Pop-up de bloqueio da exclusão de perfil com usuários vinculados (HU 870, Figma 4656:290318). */
export function RoleInUseDialog(props: RoleInUseDialogProps) {
  const vm = useRoleInUseDialog(props);

  return <RoleInUseDialogView {...vm} />;
}

export type * from "./types-role-in-use-dialog";
